import script from "./AdministratorProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectForm.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectForm.vue?vue&type=style&index=0&id=45d5f5ad&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d5f5ad"]])

export default __exports__